<template>
  <div v-if="accommodation" id="accommodation_detail" class="container accommodation_detail" itemscope
       itemtype="https://schema.org/Hotel">

    <div class="row accomodation">


      <!--hlavne obrazky -->
      <div class="col-12 order-1 order-0 top-images">


        <div class="row">
          <div class="col-12 col-lg-8 position-relative img-section">
            <figure class="detail-big-photo pointer">
              <picture @click="openGalleryNew(accommodation.imagesIncludingUnits)">

                <PartsImageSourceList :image="accommodation.getTopImage()" :sizes="[700,900,1400,1920]"/>

                <img v-if="accommodation.hasImage()"
                     :src="accommodation.getTopImage().getTyrionSrc('cachew')"
                     :alt="accommodation.getTopImage().title"
                     itemprop="photo"
                     class="big-photo img-cover" loading="lazy"
                     :width="accommodation.getTopImage().seoWidth($isDesktop ? 'cache' : 'thumb')"
                     :height="accommodation.getTopImage().seoHeight($isDesktop ? 'cache' : 'thumb')">
                <img v-else src="~/assets/img/blank.jpg"
                     :alt="accommodation.translations?.[activeLocale.code]?.title?.['-1'] ?? accommodation.title"
                     class="img-cover"
                     loading="lazy"
                     width="600" height="337">
              </picture>

              <figcaption>
                <div class="btn button-youtube rounded shadow_2"
                     v-if="accommodation.video_link && accommodation.video_link.length > 3 && loadingImages === false"
                     @click="openVideoModal">
                  <div class="d-flex align-items-center">
                    <span class="icon-youtube me-0 me-md-2"></span>
                    <span class="d-none d-md-inline">{{ $t('youtube') }}</span>
                  </div>
                </div>
                <div class="btn button-matterport rounded shadow_2"
                     v-if="accommodation.virtual_presentation && accommodation.virtual_presentation.length > 3"
                     @click="open3DVisualization">
                  <div class="d-flex align-items-center">
                    <span class="icon-matterport me-0 me-md-2"></span>
                    <span class="d-none d-md-inline">{{ $t('3D-obhliadka') }}</span>
                  </div>
                </div>

                <div class="btn btn-silver gallery-button rounded shadow_2"
                     @click="openGalleryNew( accommodation.imagesIncludingUnits)"
                     v-if="accommodation.imagesIncludingUnits.length > 3">
                  <div class="d-flex align-items-center">
                    <TyIcon icon="ty-gallery"
                            class="icon-color-dark me-2 mt-n1" width="1.2rem"/>
                    <span>
                       {{ $t('zobrazit-fotky') }} {{
                        accommodation.imagesIncludingUnits.length > 20 ? '20+' : (accommodation.imagesIncludingUnits.length)
                      }}
                    </span>
                  </div>

                </div>
              </figcaption>

            </figure>
          </div>

          <div class="d-none d-lg-block col-lg-4">
            <figure class="detail-small-photo pointer" v-if="accommodation.imagesIncludingUnits.length > 1"
                    v-for="(image, key) in accommodation.imagesIncludingUnits.slice(1,3)"
                    @click="openGalleryNew(accommodation.imagesIncludingUnits)">
              <picture>
                <PartsSrcSetImage :image="image" :t_type="'thumb_mw'" :type="'webp'"/>
                <PartsSrcSetImage :image="image" :t_type="'thumb_mw'" :type="'jpeg'"/>
                <img :src="image.getTyrionSrc('thumb_mw')"
                     :alt="(accommodation.translations?.[activeLocale.code]?.title?.['-1'] ?? accommodation.title ) + ' ' +image.title"
                     class="img-cover" loading="lazy"
                     :width="image.seoWidth('thumb_m')" :height="image.seoHeight('thumb_m')"></picture>
              <figcaption></figcaption>

            </figure>
            <figure class="detail-small-photo" v-else>
              <img src="~/assets/img/blank.jpg"
                   :alt="accommodation.translations?.[activeLocale.code]?.title?.['-1'] ?? accommodation.title "
                   class="img-cover"
                   loading="lazy"
                   width="600" height="337">
            </figure>
          </div>


        </div>


      </div>

    <div class="accommodation-over order-2">
        <div class="location-top" v-if="accommodation.location && accommodation.location.city" itemprop="address"
             itemscope itemtype="https://schema.org/PostalAddress">


          <NuxtLink
              :to="`/${activeLocale.code}-${activeLocale.code}/search?places[0][type]=country&places[0][id]=${accommodation.location.country.id}`"
              class="btn btn-white btn-rounded pointer fw-medium"
              :title="accommodation.location.country.langtitle[activeLocale.code] ?? accommodation.location.country.title">
            <TyIcon icon="ty-district" class="icon-color-first" width=".75rem" height=".75rem" stroke_width="500"/>
            {{ accommodation.location.country.langtitle[activeLocale.code] ?? accommodation.location.country.title }}
          </NuxtLink>

          <template v-if="accommodation.location.country && accommodation.location.country.code != 'ot'">
            <NuxtLink
                :to="`/${activeLocale.code}-${activeLocale.code}/search?places[0][type]=tourist_region&places[0][id]=${accommodation.location.tourist_region.id}`"
                class="btn btn-white btn-rounded pointer fw-medium"
                :title="accommodation.location.tourist_region.title">
              <TyIcon icon="ty-grove" class="icon-color-first" width=".75rem" height=".75rem" stroke_width="500"/>
              {{ accommodation.location.tourist_region.title }}
            </NuxtLink>
          </template>

          <NuxtLink
              :to="`/${activeLocale.code}-${activeLocale.code}/search?places[0][type]=city&places[0][id]=${accommodation.location.city.id}`"
              class="btn btn-white btn-rounded pointer fw-medium"
              :title="accommodation.location.city.title">
            <TyIcon icon="ty-map-pointer" class="icon-color-first" width=".75rem" height=".75rem" stroke_width="500"/>
            {{ accommodation.location.city.title }}
          </NuxtLink>

          <div v-if="accommodation.location.street && accommodation.location.street.length > 0"
               class="btn btn-silver btn-rounded pointer d-none">
            <TyIcon icon="ty-map-pointer" class="icon-color-first" width=".75rem" height=".75rem" stroke_width="500"/>
            {{ accommodation.location.street }}
          </div>

          <meta itemprop="postalCode" :content="accommodation.location.city.postcode"/>
          <meta itemprop="addressLocality" :content="accommodation.location.city.title"/>
          <meta itemprop="addressRegion" :content="accommodation.location.region.title"/>
          <meta itemprop="addressCountry" :content="accommodation.location.country.title"/>
        </div>

        <div class="share favorite d-lg-flex mt-2 mt-lg-0">
          <div @click="shareFacebookModal = true" class="btn btn-white btn-rounded pointer ">
            <TyIcon icon="ty-share" class="fw-normal first-color" height="1rem" width="1rem"/>
            <span>{{ $t('share') }}</span>
          </div>
          <ClientOnly>
            <LazyFavouriteHeartButton :item="accommodation" :iconClass="'icon-color-first'"
                                      :dislikeText="'in-favourites'"/>
          </ClientOnly>
        </div>

      </div>
      <ClientOnly>
        <ImgViewr ref="imgViewer" :initialIndex="galleryImageIndex" :onClose="closeGallery"
                  :urls="imgViewerImages"
                  :visible="galleryImageVisible"/>
      </ClientOnly>


      <!--popis a rezervacia-->
      <div class="col-12 order-3 order-lg-2">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="row">


              <!-- o ubytovani start start -->
              <div class="col-12">

                <div class="card card-detail">
                  <div class="card-body">


                    <div class="col-12 detail-header">
                      <h1 class="detail-title-h1" itemprop="name">
                        {{ accommodation.translations?.[activeLocale.code]?.title?.['-1'] ?? accommodation.title }}</h1>

                      <meta itemprop="url"
                            :content="useRuntimeConfig().public.WEB_URL + accommodation.getLinkWithSlash(activeLocale.code, accommodation.location.country ? accommodation.location.country.code : '')">


                      <div class="review-capacity-host">

                        <div class="capacity-info">
                          <div class="d-inline-flex">{{ accommodation.max_hosts_capacity }}
                            {{
                              $t($vysklonujSlovo('host', accommodation.max_hosts_capacity, 'ia', 'i'))
                            }}
                            <div class="d-inline-flex px-1" v-if="accommodation.max_hosts_capacity > 0">
                              -
                            </div>
                          </div>
                          <div class="d-inline-flex"
                               v-if="accommodation.getTotalRoomsCount('bedroom') > 0">
                            {{ accommodation.getTotalRoomsCount('bedroom') }}
                            {{
                              $t($vysklonujSlovo('spalna', accommodation.getTotalRoomsCount('bedroom'), 'e', 'i'))
                            }}
                            <div class="d-inline-flex px-1"
                                 v-if="accommodation.getTotalRoomsCount('bathroom') > 0">-
                            </div>
                          </div>
                          <div class="d-inline-flex"
                               v-if="accommodation.getTotalRoomsCount('bathroom') > 0">
                            {{ accommodation.getTotalRoomsCount('bathroom') }}
                            {{
                              $t($vysklonujSlovo('kupelna', accommodation.getTotalRoomsCount('bathroom'), 'e', 'i'))
                            }}
                          </div>
                        </div>

                        <div class="d-block d-md-inline me-2 reviews" @click="scrollToReveiws"
                             v-if="accommodation.review_count > 0">
                          <TyIcon icon="ty-star" class="icon-color-first mx-0" height="1.2rem"/>
                          {{ accommodation.review_count }}&nbsp;
                          {{ $t($vysklonujSlovo('recenzia', accommodation.review_count, 'ie', 'ii')) }}
                        </div>

                        <div class="d-block d-md-inline me-2 reviews" v-else>
                          <TyIcon icon="ty-star" class="icon-color-first me-0 mt-n1" height="1rem" width="1rem"/>
                          {{ $t('no-reviews') }}
                        </div>

                        <div class="mb-0 owner-quick-info">
                          <span class="me-2">{{ $t(accommodation.category) }}</span>
                          <span class="text-lowercase me-2">{{ $t('od-hostitela') }}</span>
                          <span>{{
                              accommodation.owner.alias && accommodation.owner.alias.length > 0 ? accommodation.owner.alias : accommodation.owner.client_name
                            }}</span>
                        </div>

                      </div>
                    </div>

                    <!-- kontakt horny start start -->
                    <div class="col-12">
                      <div class="section-title d-none">
                        <h3 class="pb-0">{{ $t('contact-for-host') }}</h3>
                      </div>

                      <div class="section-body contact-section-group">

                        <button class="btn btn-silver-big btn-phone btn-rounded" type="button"
                                @click="showContactPhoneModal">
                          <TyIcon icon="ty-phone" class="icon-color-white" width="1rem" stroke_width=".5rem"/>
                          &nbsp;{{ $t('phone-number') }}
                        </button>

                        <button class="btn btn-silver-big btn-email btn-rounded" type="button"
                                @click="showContactPhoneModal">
                          <TyIcon icon="ty-email" class="icon-color-dark" width="1.1rem" stroke_width=".5rem"/>
                          &nbsp;Email
                        </button>

                        <button v-if="accommodation.contacts.some(c => c.hasWhatsappNumber)"
                                class="btn btn-whatsapp btn-whatsapp-big btn-rounded" type="button"
                                @click="showContactWhatsappModal">
                          <TyIcon icon="ty-whatsapp" class="icon-color-dark" width="1.2rem"/>
                          &nbsp;WhatsApp
                        </button>

                        <button class="btn btn-silver-big btn-pipi btn-rounded d-none"
                                @click="showContactChatModal" type="button"
                                :disabled="loggedClient && (loggedClient.id == accommodation.owner.id)">
                          <TyIcon icon="ty-message" class="icon-color-dark" width="1.2rem" stroke_width=".5rem"/>
                          &nbsp;{{ $t('web-message') }}
                        </button>

                      </div>
                    </div>


                    <div class="card-title">
                      <h3 class="pb-0">{{ $t('o-ubytovani') }}</h3>
                    </div>
                    <p class="description-text text-dark"
                       v-if="accommodation.description && accommodation.description.length > 10"
                       :class="{'full': fullDescription}" itemprop="description"
                       v-html="(accommodation.translations?.[activeLocale.code]?.description?.['-1'] ?? accommodation.description ).replace(/\n/g, '<br>')"></p>
                    <div v-if="accommodation.description && accommodation.description.length > 400"
                         class="button-footer">
                      <button class="collapsed btn btn-silver btn-rounded fw-bolder"
                              @click="fullDescription = !fullDescription">
                        {{ $t(fullDescription ? 'hide-description' : 'show-description') }}
                      </button>

                    </div>
                  </div>
                </div>
              </div>
              <!-- o ubytovani end -->


              <!-- hlavne vybavenie ubytovania -->
              <div class="col-12 main-accommodation-equipments">
                <div class="card card-detail">
                  <div class="card-body">
                    <div class="card-title">
                      <h3>{{ $t('main-accommodation-facilities') }}</h3>
                    </div>
                    <div class="equipments-group" :class="fullEquipList ? 'equip-show' : 'equip-hide'">

                      <div class="equipment">
                        <div class="left-icon">
                          <TyIcon icon="ty-home-1" class="icon-color-first" width="3rem" height="3rem"
                                  v-if="accommodation.reserve_whole_object === true"/>
                          <TyIcon icon="ty-houses" class="icon-color-first" width="3rem" height="3rem"
                                  v-if="accommodation.reserve_whole_object === false"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0" v-if="accommodation.reserve_whole_object === false"> {{
                              $t('reserve-units')
                            }}</h4>
                          <h4 class="h5 mb-0" v-if="accommodation.reserve_whole_object === true">
                            {{ $t('reserve-whole-object') }}</h4>
                          <p class="mb-0" v-if="accommodation.reserve_whole_object === false">
                            {{ $t('you-can-book-separate-accommodation-units-in-this-accommodation') }}
                          </p>
                          <p class="mb-0" v-if="accommodation.reserve_whole_object === true">
                            {{ $t('you-will-have-the-whole-object-just-for-yourself') }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment"
                           v-if="accommodation.equipment['internet-connections'] && accommodation.equipment['internet-connections'].length > 0 && accommodation.equipment['internet-connections'].indexOf('no-without-internet') === -1">
                        <div class="left-icon">
                          <TyIcon icon="ty-smart-house" class="icon-color-first" width="3rem"
                                  height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('internet-connections') }}
                          </h4>
                          <p class="mb-0">
                            {{ $t('equipment-' + accommodation.equipment['internet-connections'][0]) }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment"
                           v-if="accommodation.pet_policy !== 'not-allowed'">
                        <div class="left-icon">
                          <TyIcon icon="ty-pawprint" class="icon-color-first" width="3rem" height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('pets-allowed') }}
                          </h4>
                          <p class="mb-0">
                            {{ $t('pet-policy-' + accommodation.pet_policy) }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment" v-else>
                        <div class="left-icon pets-not-allowed">
                          <TyIcon icon="ty-pawprint" class="icon-color-first" width="3rem" height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('animals') }}
                          </h4>
                          <p class="mb-0">
                            {{ $t('pet-policy-' + accommodation.pet_policy) }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment"
                           v-if="accommodation.parking_places_count > 0">
                        <div class="left-icon">
                          <TyIcon icon="ty-parking" class="icon-color-first" width="3rem" height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('paring-near-object') }}
                          </h4>
                          <p class="mb-0">
                            {{ $t('parking') }}
                            <span class="text-lowercase">{{
                                $t('parking-type-' + accommodation.parking_distance)
                              }}.</span>
                            {{
                              accommodation.parking_possibilities.map(p => $t('parking-possibility-' + p)).join(', ')
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment"
                           v-if="accommodation.equipment['opportunities-for-children'] && accommodation.equipment['opportunities-for-children'].length > 1">
                        <div class="left-icon">
                          <TyIcon icon="ty-playground" class="icon-color-first" width="3rem"
                                  height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('ideal-for-childrens') }}
                          </h4>
                          <p class="mb-0">
                            {{
                              accommodation.equipment['opportunities-for-children'].map(p => $t('equipment-' + p)).join(', ')
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment"
                           v-if="accommodation.equipment['at-the-object'] && accommodation.equipment['at-the-object'].indexOf('gazebo') > -1">
                        <div class="left-icon">
                          <TyIcon icon="ty-event" class="icon-color-first" width="2.7rem" height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('equipment-gazebo') }}
                          </h4>
                          <p class="mb-0">
                            {{
                              accommodation.equipment['at-the-object'].filter(p => ['fireplace', 'outdoor-fireplace', 'barbecue-grill', 'kettle'].indexOf(p) > -1).map(p => $t('equipment-' + p)).join(', ')
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="equipment"
                           v-if="accommodation.equipment['wellness-and-relax'] && accommodation.equipment['wellness-and-relax'].length > 0">
                        <div class="left-icon">
                          <TyIcon icon="ty-wellness" class="icon-color-first" width="3rem" height="3rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">
                            {{ $t('wellness-and-relax') }}
                          </h4>
                          <p class="mb-0">
                            {{
                              accommodation.equipment['wellness-and-relax'].slice(0, 4).map(p => $t('equipment-' + p)).join(', ')
                            }}
                          </p>
                        </div>
                      </div>

                      <!-- doplnkove vybavenie ubytovania start -->
                      <div class="equipment"
                           v-for="equipmentGroup in equipmentGroups">
                        <div class="left-icon">
                          <TyIcon :icon="equipmentGroup.icon" :stroke="equipmentGroup.stroke"
                                  :stroke_width="equipmentGroup.stroke_width"
                                  class="icon-color-first me-4" width="2.5rem" height="2.5rem"/>
                        </div>
                        <div>
                          <h4 class="h5 mb-0">{{ $t(equipmentGroup.code) }}</h4>
                          <span class="mb-0" v-for="item in equipmentGroup.items">{{
                              $t('equipment-' + item)
                            }}, </span>
                        </div>
                      </div>
                      <!-- doplnkove vybavenie ubytovania end -->

                    </div>


                    <div class="button-footer">
                      <button class="btn btn-silver btn-rounded"
                              @click="fullEquipList = !fullEquipList">
                        {{ $t(fullEquipList ? 'show-less' : 'show-more') }}
                      </button>
                    </div>

                  </div>
                </div>

              </div>
              <!-- hlavne vybavenie ubytovania end -->


              <!-- izby, jendotky start -->
              <div class="col-12" v-if="accommodation.reserve_whole_object">
                <div class="card card-detail">
                  <div class="card-body">
                    <ClientOnly>
                      <RoomSlider class="pointer" :item="accommodation" :onClickItem="showUnit"/>
                      <template slot="fallback">
                        <div class="row">
                          <div class="col-12 col-lg-6" v-for="i in [0,1]">
                            <div class="temp-content-card"></div>
                          </div>
                        </div>
                      </template>
                    </ClientOnly>
                  </div>
                </div>
              </div>

              <div class="col-12" v-else>
                <div class="card card-detail">
                  <div class="card-body">
                    <ClientOnly>
                      <UnitSlider class="pointer" :item="accommodation" :onClickItem="showUnit"/>
                      <template slot="fallback">
                        <div class="row">
                          <div class="col-12 col-lg-6" v-for="i in [0,1]">
                            <div class="temp-content-card"></div>
                          </div>
                        </div>
                      </template>
                    </ClientOnly>
                  </div>
                </div>
              </div>
              <!-- izby, jendotky end -->


              <!-- kalendar obsadenosti start-->
              <div class="calendar-double col-12 position-relative">
                <div class="card card-detail">
                  <div class="card-body">
                    <div class="card-title">
                      <h3 class="mb-0">{{ $t('occupacy-calendar') }}</h3>
                    </div>
                    <ClientOnly>
                      <LazyWidgetAccommodationDetailAccDetailCalendarOccupacy
                          :accommodation="accommodation"
                          @clickAction="showReservation"/>
                    </ClientOnly>
                  </div>
                </div>
              </div>

              <!-- kalendar obsadenosti end-->

              <!-- cennik start-->
              <div class="col-12">
                <ClientOnly>
                  <LazyWidgetAccommodationDetailAccDetailPriceList
                      :accommodation="accommodation"
                      :activeLocale="activeLocale"/>
                </ClientOnly>
              </div>
              <!-- cennik end-->


              <!-- kontakt start -->
              <div class="col-12">

                <div class="card card-detail">
                  <div class="card-body">
                    <div class="card-title">
                      <h3>{{ $t('contact-for-host') }}</h3>
                    </div>
                    <div class="contact-group">
                      <div class="col owner-card">
                        <figure class="user-photo-round-bigger">
                          <picture>
                            <PartsSrcSetImage v-if="accommodation.owner.hasLogo"
                                              :image="accommodation.owner.logo"
                                              :t_type="'thumb_mw'" :type="'webp'"/>
                            <PartsSrcSetImage v-if="accommodation.owner.hasLogo"
                                              :image="accommodation.owner.logo"
                                              :t_type="'thumb_mw'" :type="'jpeg'"/>
                            <img v-if="accommodation.owner.hasLogo"
                                 :src="accommodation.owner.logo.getTyrionSrc('thumb_mw')"
                                 :alt="(accommodation.translations?.[activeLocale.code]?.title?.['-1'] ?? accommodation.title ) + '  ' + $t('ubytovatel')"
                                 class="img-cover"
                                 loading="lazy"
                                 :width="accommodation.owner.logo.seoWidth('thumb_m')"
                                 :height="accommodation.owner.logo.seoHeight('thumb_m')">
                            <img v-else src="~/assets/img/blank.jpg"
                                 :alt="(accommodation.translations?.[activeLocale.code]?.title?.['-1'] ?? accommodation.title ) + '  ' + $t('ubytovatel')"
                                 class="img-cover"
                                 loading="lazy"
                                 width="600" height="337">
                          </picture>
                        </figure>

                        <div class="text-info-owner">
                          <p class="h4 mb-0">
                            {{
                              accommodation.owner.alias && accommodation.owner.alias.length > 0 ? accommodation.owner.alias : accommodation.owner.client_name
                            }}</p>

                          <p class="text-muted small mb-0">{{ $t(accommodation.owner_living_policy) }}</p>

                          <p class="text-muted small mb-0">{{ $t('member-from') }}
                            {{ formatTime(accommodation.owner.created_at, 'MMMM YYYY') }}
                          </p>
                          <p class="text-muted small mb-0"
                             v-if="accommodation.owner.params && accommodation.owner.params.languages">
                            {{ accommodation.owner.params.languages.map(eq => $t('landlord-lang-' + eq)).join(', ') }}
                          </p>

                          <template v-if="accommodation.review_count == 0">
                            <button class="btn btn-first rounded fw-bolder d-flex gap-2 align-items-center mt-2"
                                    @click="addReviewModalOpen = true">
                              <TyIcon icon="ty-plus"/>
                              <span>{{ $t('add-review') }}</span>
                            </button>
                          </template>

                          <p class="d-none owner-note"
                             v-if="accommodation.owner.note && accommodation.owner.note.length > 0">
                            {{ accommodation.owner.note }}</p>
                        </div>

                      </div>
                      <div class="col contact-buttons">
                        <!-- kontakt spodny start start -->


                        <div class="section-body contact-section-group">

                          <button class="btn btn-silver-big btn-rounded" type="button"
                                  @click="showContactPhoneModal">
                            <TyIcon icon="ty-phone" class="icon-color-dark" width="1rem" stroke_width=".5rem"/>
                            &nbsp;{{ $t('phone-number') }}
                          </button>

                          <button class="btn btn-silver-big btn-rounded" type="button"
                                  @click="showContactPhoneModal">
                            <TyIcon icon="ty-email" class="icon-color-dark" width="1.1rem" stroke_width=".5rem"/>
                            &nbsp;Email
                          </button>

                          <button v-if="accommodation.contacts.some(c => c.hasWhatsappNumber)"
                                  class="btn btn-whatsapp btn-whatsapp-big btn-rounded" type="button"
                                  @click="showContactWhatsappModal">
                            <TyIcon icon="ty-whatsapp" class="icon-color-dark" width="1.2rem"/>
                            &nbsp;WhatsApp
                          </button>

                          <button class="btn btn-silver-big btn-rounded"
                                  @click="showContactChatModal" type="button"
                                  :disabled="loggedClient && (loggedClient.id == accommodation.owner.id)">
                            <TyIcon icon="ty-message" class="icon-color-dark" width="1.2rem" stroke_width=".5rem"/>
                            &nbsp;{{ $t('web-message') }}
                          </button>

                        </div>
                      </div>
                    </div>
                    <!-- kontakt spodny start end -->
                  </div>
                </div>
              </div>
              <!-- kontakt start -->

              <!-- recenzie start-->
              <div class="col-12" v-if="accommodation.review_count > 0">
                <div class="card card-detail">
                  <div class="card-body">

                    <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating"
                         class="d-none">
                      <meta itemprop="worstRating" content="1">
                      <span itemprop="ratingValue">{{ accommodation.review_rating }}</span>/
                      <span itemprop="bestRating">{{ accommodation.review_rating }}</span> stars - based on
                      <span itemprop="reviewCount">{{ accommodation.reviews.length }}</span> reviews
                    </div>

                    <div class="card-title" ref="reviews_content">
                      <h3>{{ $t('customers-reviews') }}</h3>
                    </div>

                    <div class="top-rating-flex">
                      <div class="acc-detail-top-rating">
                        <div class="rating-number">{{ accommodation.review_rating.toFixed(1).replace('.', ',') }}</div>
                        <div class="rating-count-stars">
                          <div class="rating-star" v-for="ratingStar in Math.round(accommodation.review_rating)">
                            <TyIcon icon="ty-star" class="" width="1.5rem"/>
                          </div>
                        </div>
                        <div class="rating-text">
                        <span class="hodnotil">
                          {{ $t($vysklonujSlovo('Hodnotil', accommodation.review_count, 'i', 'o')) }}
                        </span>
                          <span class="count">{{ accommodation.review_count }}</span>
                          <span class="zakaznik" v-if="accommodation.review_count == 1">{{ $t('zakaznik') }}</span>
                          <span class="zakaznik"
                                v-else-if="accommodation.review_count > 1 && accommodation.review_count <= 5">zakaznici</span>
                          <span class="zakaznik" v-else-if="accommodation.review_count > 5">zakaznikov</span>
                        </div>
                        <button class="btn btn-first rounded d-flex gap-2 align-items-center"
                                @click="addReviewModalOpen = true">
                          <TyIcon icon="ty-plus"/>
                          <span>{{ $t('add-review') }}</span>
                        </button>
                      </div>

                      <div class="rightSideRating" v-if="hasRatings">
                        <div v-for="ss in 5" :key="ss" class="rating-item">
                          <span class="rating-label">{{ (6 - ss) }}.</span>
                          <TyIcon icon="ty-star" class="star-icon" width="1.5rem" />
                            <div class="progress">
                              <div
                                  class="progress-bar"
                                  role="progressbar"
                                  :style="{ width: progressBarWidth(6 - ss) + '%' }"
                                  :aria-valuenow="progressBarWidth(6 - ss)"
                                  aria-valuemin="0"
                                  aria-valuemax="100">
                              </div>
                            </div>
                          <span class="rating-count">{{ accommodation.reviewNumeredRating[6 - ss] }} x</span>
                        </div>
                      </div>
                    </div>

                    <LazyWidgetAccommodationDetailAccDetailReviewsSlider
                        :accommodation="accommodation" :activeLocale="activeLocale"/>

                    <div class="button-footer">
                      <button class="btn btn-silver btn-rounded" @click="showReviews">
                        {{ $t('show-reviews') }}
                      </button>
                    </div>


                  </div>
                </div>


              </div>
              <!-- recenzie end-->


              <!-- kde budete start-->
              <div class="col-12">
                <div class="card card-detail">
                  <div class="card-body">
                    <div class="card-title">
                      <h3 class="mb-0">{{ $t('kde-budete') }}</h3>
                    </div>

                    <ClientOnly>
                      <LazyPartsUniMap
                          :center="[accommodation.location.latitude, accommodation.location.longitude]"
                          :markerPosition="[accommodation.location.latitude, accommodation.location.longitude]"
                          ref="map" :zoom="16"
                          :mapContainerOptions="{gestureHandling: true}"/>
                      <template slot="fallback">
                        <div class="temp-content-card"></div>
                      </template>
                    </ClientOnly>

                    <div class="map-btn-group">
                      <button @click="viewInGoogleMaps" class="btn btn-first">
                        {{ $t('View in Google Maps') }}
                      </button>
                      <button @click="navigateWithGoogleMaps" class="btn btn-outline-first">
                        {{ $t('Navigate to accommodation') }}
                      </button>
                    </div>


                    <div itemprop="geo" itemscope itemtype="https://schema.org/GeoCoordinates">
                      <meta itemprop="latitude" :content="String(accommodation.location.latitude)"/>
                      <meta itemprop="longitude" :content="String(accommodation.location.longitude)"/>
                    </div>

                    <div class="d-none">
                      <p>
                    <span class="h6 d-block mb-0 mt-2" v-if="accommodation.location && accommodation.location.city">
                      {{ accommodation.location.city.title }},&nbsp;{{ accommodation.location.street }}&nbsp;{{
                        accommodation.location.street_number
                      }},&nbsp;{{ accommodation.location.country.title }}
                    </span>

                        <span class="small"
                              v-if="accommodation.location && accommodation.location.tourist_region && accommodation.location.tourist_region.id > 0 && accommodation.location.tourist_region.langdescription && accommodation.location.tourist_region.langdescription[activeLocale.code]">
                      {{ accommodation.location.tourist_region.langdescription[activeLocale.code].substr(0, 305) }}...
                    </span>
                      </p>
                      <button class="btn btn-silver btn-rounded mt-2 fw-bolder"
                              @click="showLocationAdditionalInfo(accommodation.location.tourist_region.id)">
                        {{ $t('show-more-of-location') }}
                      </button>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-12"
                   v-if="accommodation.attractions && accommodation.attractions.length > 0">

                <div class="card card-detail">
                  <div class="card-body">

                    <ClientOnly>
                      <AttractionSlider class="attractions" :accommodation="accommodation"/>
                      <template slot="fallback">
                        <div class="row">
                          <div class="col-4 mb-3 mb-md-2" v-for="i in [0,1,2]">
                            <div class="temp-content-card"></div>
                          </div>
                        </div>
                      </template>
                    </ClientOnly>
                  </div>
                </div>
              </div>
              <!-- kde budete end-->


              <!-- pravidla pobytu start-->
              <div class="col-12">
                <div class="card card-detail">
                  <div class="card-body">
                    <div class="card-title">
                      <h3 class="mb-0">{{ $t('rules-of-accommodation') }}</h3>
                    </div>
                    <div class="rules">
                      <div class="rule">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('arrival-time') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{
                            $t('from') + ' ' + accommodation.time_arrival_from + ' - ' + $t('to') + ' ' + accommodation.time_arrival_to
                          }}
                        </p>
                        <meta itemprop="checkinTime" :content="accommodation.time_arrival_from">
                      </div>
                      <div class="rule">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('leave-time') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{
                            $t('from') + ' ' + accommodation.time_leave_from + ' - ' + $t('to') + ' ' + accommodation.time_leave_to
                          }}
                        </p>
                        <meta itemprop="checkoutTime" :content="accommodation.time_leave_to">

                      </div>
                      <div class="rule">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('smoking-policy-title') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{ $t('smoking-policy-' + accommodation.smoking_policy) }}.</p>
                      </div>
                      <div class="rule"
                           v-if="accommodation.owner.params && accommodation.owner.params.languages && accommodation.owner.params.languages.length > 0">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('landlord-lang-title') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{ accommodation.owner.params.languages.map(eq => $t('landlord-lang-' + eq)).join(', ') }}
                        </p>
                      </div>
                      <div class="rule"
                           v-if="accommodation.owner_living_policy">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('owner-living-in-object') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{ $t('owner-l-policy-' + accommodation.owner_living_policy) }}.</p>
                      </div>
                      <div class="rule" v-if="accommodation.equipment.fence">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('fence-title') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">{{
                            $t('fence-' + accommodation.equipment.fence)
                          }}.</p>
                      </div>
                      <div class="rule" v-if="accommodation.equipment.heating">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('heating-title') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{
                            accommodation.equipment.heating.map(eq => $t('heating-' + eq)).join(', ')
                          }}
                        </p>
                      </div>
                      <div class="rule" v-if="accommodation.equipment.food">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('food-title') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">{{
                            accommodation.equipment.food.map(eq => $t('food-' + eq)).join(', ')
                          }}</p>
                      </div>
                      <div class="rule"
                           v-if="accommodation.equipment['additional-services'] && accommodation.equipment['additional-services'].includes('newborn-cradle')">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('children-cradle') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">{{ $t('is-available') }}</p>
                      </div>
                      <div class="rule"
                           v-if="accommodation.equipment.wheelchair_accessible && accommodation.equipment.wheelchair_accessible">
                        <h4 class="h5 mb-1">
                          <strong>{{ $t('wheelchair-accessible-title') }}</strong>
                        </h4>
                        <p class="mb-0 text-muted">
                          {{
                            $t('wheelchair-accessible-' + accommodation.equipment.wheelchair_accessible)
                          }}.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- podmienky stornovania-->
                <div class="card card-detail"
                     v-if="accommodation.storno_conditions && accommodation.storno_conditions.length > 3">
                  <div class="card-body">
                    <div class="card-title">
                      <h3 class="mb-0">{{ $t('storno-conditions') }}</h3>
                    </div>
                    <div class="rules">
                      <div class="rule-warning">
                        <p class="white-space-pre">
                          <template
                              v-if="accommodation.storno_conditions.length > 300 && fullStornoCondition === false">
                            {{
                              (accommodation.translations?.[activeLocale.code]?.storno_conditions?.['-1'] ?? accommodation.storno_conditions).substring(0, 300)
                            }}...
                          </template>
                          <template v-else>
                            {{
                              (accommodation.translations?.[activeLocale.code]?.storno_conditions?.['-1'] ?? accommodation.storno_conditions)
                            }}
                          </template>
                        </p>

                      </div>
                    </div>

                    <div class="button-footer" v-if="accommodation.storno_conditions.length > 300">
                      <button class="collapsed btn btn-silver btn-rounded" rel="ugc,nofollow"
                              @click="fullStornoCondition = !fullStornoCondition">
                        {{ $t(fullStornoCondition ? 'show-less' : 'show-more') }}
                      </button>
                    </div>

                  </div>
                </div>

                <div class="card card-detail" v-if="accommodation.owner_note && accommodation.owner_note.length > 3">
                  <div class="card-body">
                    <div class="card-title">
                      <h3 class="mb-0">{{ $t('owner-note') }}</h3>
                    </div>
                    <template
                        v-if="accommodation.owner_note.length > 300 && fullOrderNote === false">
                      {{
                        (accommodation.translations?.[activeLocale.code]?.owner_note?.['-1'] ?? accommodation.owner_note).substring(0, 300)
                      }}...
                    </template>
                    <template v-else>
                      {{
                        (accommodation.translations?.[activeLocale.code]?.owner_note?.['-1'] ?? accommodation.owner_note)
                      }}
                    </template>
                    <div class="button-footer" v-if="accommodation.owner_note.length > 300">
                      <button class="collapsed btn btn-silver btn-rounded" rel="ugc,nofollow"
                              @click="fullOrderNote = !fullOrderNote">
                        {{ $t(fullOrderNote ? 'show-less' : 'show-more') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- pravidla pobytu end-->


            </div>
          </div>
          <!-- rezervacia -->
          <div class="col-12 col-md-8 offset-md-2 offset-lg-0 mb-4 col-lg-4" v-if="$isDesktop()">
            <ReservationCard :accommodation="accommodation" :client="loggedClient" ref="reservationContent"
                             @contactHostAction="showContactPhoneModal"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 position-relative">

        <ReservationCardPhone :accommodation="accommodation" :client="loggedClient" v-if="!$isDesktop()"
                              @contactHostAction="showContactPhoneModal" ref="reservationContent"/>

      </div>
    </div>

    <BModal :open="reviewModal" centered size="lg"
            @hide="reviewModal = false">
      <HCHModalHeader :close="() => reviewModal = false"/>

      <div class="hch_modal-body review_modal-body">
        <ReviewsContent :accommodation="accommodation"
                        :activeLocale="activeLocale"
                        v-if="reviewModal"/>
      </div>
    </BModal>

    <BModal :open="addReviewModalOpen" centered size="review"
            @hide="addReviewModalOpen = false">

      <HCHModalHeader :close="() => addReviewModalOpen = false"/>

      <div class="hch_modal-body review_add_modal-body">

        <ReviewAddContent :accommodation="accommodation"
                          :activeLocale="activeLocale"
                          v-if="addReviewModalOpen"/>
      </div>
    </BModal>

    <BModal :open="accommodationUnitModal" centered size="lg"
            @hide="closeUnitModal">

      <HCHModalHeader :close="closeUnitModal"/>
      <div class="hch_modal-body">
        <ModalUnitContent v-if="accommodationUnitModal && openedUnit !== null" :unit="openedUnit"
                          :room="openedUnitRoom"/>
      </div>
    </BModal>

    <BModal :open="touristRegionModal" centered size="xl"
            @hide="closeTouristRegionModal">

      <HCHModalHeader :close="closeTouristRegionModal"/>
      <div class="hch_modal-body">
        <ModalTouristRegion v-if="touristRegionModal" :region_id="touristRegionId"
                            @hideModal="closeTouristRegionModal"/>
      </div>
    </BModal>

    <BModal :open="shareFacebookModal" centered size="md"
            @hide="() => shareFacebookModal = false">

      <HCHModalHeader :close="() => shareFacebookModal = false"/>
      <div class="hch_modal-body">
        <ModalShareFacebook v-if="shareFacebookModal" :accommodation="accommodation"/>
      </div>
    </BModal>

    <BModal :open="ownerContactModal" centered size="md"
            @hide="() => ownerContactModal = false">

      <HCHModalHeader :close="() => ownerContactModal = false"/>
      <div class="hch_modal-body">
        <OwnerChatContent v-if="loggedClient && loggedClient.id > 0 && ownerContactModal"
                          :accommodation="accommodation"
                          :client="loggedClient"/>
        <template v-else>
          <div class="alert alert-info">
            {{ $t('login-required-to-make-a-reservation') }}
          </div>
          <div class="text-end">
            <button class="btn btn-first btn-rounded"
                    @click="() => {ownerContactModal = false; showLoginChat()}">
              {{ $t('log-in') }}
            </button>
          </div>
        </template>
      </div>
    </BModal>

    <BModal :open="ownerContactPhoneModal" centered size="md"
            @hide="() => ownerContactPhoneModal = false">

      <HCHModalHeader :close="() => ownerContactPhoneModal = false"/>
      <div class="hch_modal-body">
        <OwnerPhoneContent
            v-if="ownerContactPhoneModal"
            :accommodation="accommodation"
            :client="loggedClient"/>
      </div>
    </BModal>

    <BModal :open="ownerContactWhatsAppModal" centered size="md"
            @hide="() => ownerContactWhatsAppModal = false">

      <HCHModalHeader :close="() => ownerContactWhatsAppModal = false"/>
      <div class="hch_modal-body">
        <OwnerWhatsappContent :accommodation="accommodation"/>
      </div>
    </BModal>

    <BModal :open="virtualPresentationModal" centered size="xl"
            @hide="() => virtualPresentationModal = false">

      <HCHModalHeader :close="() => virtualPresentationModal = false"/>
      <div class="hch_modal-body" v-if="virtualPresentationModal">
        <LazyWidgetAccommodationDetailAccDetail3dPresentationContent
            :link="accommodation.virtual_presentation"/>
      </div>
    </BModal>

    <BModal :open="videoPresentationModal" centered size="xl"
            @hide="() => videoPresentationModal = false">

      <HCHModalHeader :close="() => videoPresentationModal = false"/>
      <div class="hch_modal-body" v-if="videoPresentationModal">
        <LazyWidgetAccommodationDetailAccDetailVideoContent :link="accommodation.video_link"/>
      </div>
    </BModal>

    <BModal :open="newModalGalleryToggle" centered size="fullscreen"
            @hide="() => {newModalGalleryToggle = false; newModalGallery = false}">

      <HCHModalHeader :close="() => {newModalGalleryToggle = false; newModalGallery = false}"/>
      <div class="hch_modal-body" v-if="newModalGallery !== false">
        <LazyWidgetAccommodationDetailAccDetailNewGalleryContent :images="newModalGallery" @openGallery="openGallery"/>
      </div>
    </BModal>


  </div>
  <div v-else>
    <div class="container">
      <div class="alert alert-danger">
        Unable to get advertisement.
      </div>
    </div>
  </div>
  <div itemscope itemtype="https://schema.org/FAQPage" v-if="accommodation" class="d-none">
    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
         v-if="accommodation.equipment['internet-connections'] && accommodation.equipment['internet-connections'].length > 0 && accommodation.equipment['internet-connections'].indexOf('no-without-internet') === -1">
      <h2 itemprop="name">{{ $t('internet-connections') }}?</h2>
      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          {{ $t('equipment-' + accommodation.equipment['internet-connections'][0]) }}
        </div>
      </div>
    </div>
    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
         v-if="accommodation.pet_policy !== 'not-allowed'">
      <h2 itemprop="name">{{ $t('pets-allowed') }}?</h2>
      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          {{ $t('pet-policy-' + accommodation.pet_policy) }}
        </div>
      </div>
    </div>
    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
         v-if="accommodation.parking_places_count > 0">
      <h2 itemprop="name">{{ $t('paring-near-object') }}?</h2>
      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          {{ $t('parking') }}
          <span class="text-lowercase">{{ $t('parking-type-' + accommodation.parking_distance) }}.</span>
          {{ accommodation.parking_possibilities.map(p => $t('parking-possibility-' + p)).join(', ') }}
        </div>
      </div>
    </div>
    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
         v-if="accommodation.equipment['opportunities-for-children'] && accommodation.equipment['opportunities-for-children'].length > 1">
      <h2 itemprop="name">{{ $t('ideal-for-childrens') }}?</h2>
      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          {{ accommodation.equipment['opportunities-for-children'].map(p => $t('equipment-' + p)).join(', ') }}
        </div>
      </div>
    </div>
    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
         v-if="accommodation.equipment['at-the-object'] && accommodation.equipment['at-the-object'].indexOf('gazebo') > -1">
      <h2 itemprop="name"> {{ $t('equipment-gazebo') }}?</h2>
      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          {{
            accommodation.equipment['at-the-object'].filter(p => ['fireplace', 'outdoor-fireplace', 'barbecue-grill', 'kettle'].indexOf(p) > -1).map(p => $t('equipment-' + p)).join(', ')
          }}
        </div>
      </div>
    </div>
    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
         v-if="accommodation.equipment['wellness-and-relax'] && accommodation.equipment['wellness-and-relax'].length > 0">
      <h2 itemprop="name"> {{ $t('wellness-and-relax') }}?</h2>
      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div itemprop="text">
          {{
            accommodation.equipment['wellness-and-relax'].slice(0, 4).map(p => $t('equipment-' + p)).join(', ')
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, getCurrentInstance, onMounted, onUnmounted, PropType, ref} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/accommodation_detail";
import {useNuxtApp, useState, useRuntimeConfig} from "#app";
import "~/assets/less/acc_detail_1.min.css";
import ImgViewr from 'vue-img-viewr';
import 'vue-img-viewr/styles/index.css';
import ReviewsContent from "./acc_detail/acc_detail_reviews"
import ReviewAddContent from "./acc_detail/acc_detail_review_add"
import ModalUnitContent from "./acc_detail/acc_detail_modal_unit_or_room_info.vue";
import ModalTouristRegion from "./acc_detail/acc_detail_modal_region_info.vue";
import ModalShareFacebook from "./acc_detail/acc_detail_modal_share.vue";
import ReservationCard from "./acc_detail/right_reservation/acc_detail_right_reservation";
import ReservationCardPhone from "./acc_detail/right_reservation/acc_detail_phone_reservation_bottom";
import OwnerChatContent from "./acc_detail/acc_detail_contact_host"
import OwnerPhoneContent from "./acc_detail/acc_detail_contact_phone"
import OwnerWhatsappContent from "./acc_detail/acc_detail_contact_whatsapp"
import LazyFavouriteHeartButton from "~/components/web/parts/favourite_heart_button";
import BModal from "~/components/web/parts/b-modal";
import {resolveComponent} from "#imports";
import Image from "../../../../lib/models/Image";
import AccommodationUnit from "../../../../lib/models/AccommodationUnit";
import AccommodationRoom from "../../../../lib/models/AccommodationRoom";
import {TyrionResourceImageType} from "../../../../lib/enums/TyrionResourceImageType";
import {formatTime} from "../../../../lib/functions";
import equipments from "~/lib/data/acc_equipment.json";
import HCHModalHeader from "~/components/web/parts/modals/hch_modal_header"
import {useStateFunctionBodyClass} from "../../../../composables/state/body_class";
import {getCurrentUser} from "../../../../composables/auth/useAuthUser";
import {useStateFunctionViewed} from "../../../../composables/state/viewed";
import {obtainActiveLocale} from "../../../../composables/master_page";
import {GATracker} from "../../../../composables/ga_tracker";
import owner from "../../../admin/accommodation/edit/basic_info/owner.vue";

const {$vysklonujSlovo, $tyrionApi, $showWebp, $isDesktop, $t} = useNuxtApp();

const activeLocale = obtainActiveLocale();
const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});


const {accommodation} = useWidget(props.widget);
const RoomSlider = resolveComponent("LazyWidgetAccommodationDetailAccDetailRoomsSlider");
const UnitSlider = resolveComponent("LazyWidgetAccommodationDetailAccDetailUnitsSlider");
const AttractionSlider = resolveComponent("LazyWidgetAccommodationDetailAccDetailAttractionSlider");
const {GATrackEvent} = GATracker();

const galleryImageIndex = ref<number>(1);
const selectedFonts = ref([]);
const galleryImageVisible = ref<boolean>(false);
const fullDescription = ref<boolean>(false);
const fullStornoCondition = ref<boolean>(false);
const fullOrderNote = ref<boolean>(false);
const imgViewerImages = ref<Array<Image>>([]);
const reviewModal = ref<boolean>(false);
const accommodationUnitModal = ref<boolean>(false);
const addReviewModalOpen = ref<boolean>(false);
const touristRegionModal = ref<boolean>(false);
const shareFacebookModal = ref<boolean>(false);
const loadingImages = ref<boolean>(true);
const ownerContactModal = ref<boolean>(false);
const ownerContactPhoneModal = ref<boolean>(false);
const ownerContactWhatsAppModal = ref<boolean>(false);
const virtualPresentationModal = ref<boolean>(false);
const videoPresentationModal = ref<boolean>(false);
const openedUnit = ref<AccommodationUnit | null>(null);
const openedUnitRoom = ref<AccommodationRoom | null>(null);
const touristRegionId = ref<number | null>(null);
const imgViewer = ref(null);
const loggedClient = getCurrentUser();
const reviews_content = ref(null);
const reservationContent = ref(null);
const newModalGallery = ref(false);
const newModalGalleryToggle = ref(false);
const map = ref(null);
const latitude = accommodation.location.latitude; // Replace with your GPS latitude
const longitude = accommodation.location.longitude; // Replace with your GPS longitude
const {removeBodyClass} = useStateFunctionBodyClass();
const {addToViewed} = useStateFunctionViewed();

const viewInGoogleMaps = () => {
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  window.open(googleMapsUrl, '_blank');
};

const navigateWithGoogleMaps = () => {
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  window.open(googleMapsUrl, '_blank');
};

const equipmentGroups = computed(() => {
  return equipments.filter(eq => {
    if (['internet-connections', 'opportunities-for-children', 'wellness-and-relax'].indexOf(eq.code) > -1) {
      return false;
    }
    return eq.items.some(i => accommodation.equipment[eq.code] !== undefined && accommodation.equipment[eq.code].indexOf(i) > -1)
  }).map(eq => {
    eq.items = eq.items.filter(i => accommodation.equipment[eq.code] !== undefined && accommodation.equipment[eq.code].indexOf(i) > -1)
    return eq;
  })
})

const GATrackerItemAccommodation = computed(() => {
  return {
    item_id: accommodation.id,
    item_name: accommodation.title,
    item_category: accommodation.category,
    item_variant: accommodation.location.tourist_region ? accommodation.location.tourist_region.code : ""
  }
})


onMounted(() => {
  addToViewed({id: accommodation.id, date: new Date()});
  $tyrionApi.postTyrionUrl('/api3/accommodation/images', {
    body: {
      acc: accommodation.link,
    },
    cacheTime: (60 * 5)
  }).then(res => {
    accommodation.images = res.data.map(i => (new Image()).fromObject(i));
    loadingImages.value = false;
  }).catch(e => {
    loadingImages.value = false;
    console.log((e.response && e.response.data && e.response.data.message) ? e.response.data.message : `Images error: ${e.message}`);
  });

  GATrackEvent({
    event: 'view_item',
    language: activeLocale.code,
    action: 'visit',
    label: 'Open accommodation',
    value: accommodation.link,
    items: [
      {
        item_id: accommodation.id,
        item_name: accommodation.title,
        item_category: accommodation.category,
        item_variant: accommodation.location.tourist_region ? accommodation.location.tourist_region.code : ""
      }
    ]
  });
})

onUnmounted(() => {
  removeBodyClass('no-scroll');
  // this.$store.commit('modals/clearLoginModalCallback'); TODO
})

const openGalleryNew = (images) => {
  newModalGallery.value = images;
  newModalGalleryToggle.value = true;
};

const openGallery = (index, images) => {
  imgViewerImages.value = images.map((image: Image) => {
    return image.getTyrionSrc(TyrionResourceImageType.CacheSrcWatermark, $showWebp ? 'webp' : null);
  });

  setTimeout(() => {
    galleryImageIndex.value = index;
    galleryImageVisible.value = true;
  }, 100)

  GATrackEvent({
    event: 'show_accommodation_gallery',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation photo gallery',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  }, 300);
}

const closeGallery = () => {
  galleryImageVisible.value = false;
  imgViewer.value.index = 0;
}

const showReviews = () => {
  reviewModal.value = true;

  GATrackEvent({
    event: 'show_accommodation_reviews',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation reviews',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const showLoginChat = () => {
  ownerContactModal.value = false;

  setTimeout(() => {
    useState('login-modal').value = true;
    useState('login-modal-callbacks', () => []).value.push(() => {
      useState('login-modal').value = false;
      setTimeout(() => {
        ownerContactModal.value = true;
      }, 300);
    });
  }, 300);

}


const showUnit = (unit, room) => {
  accommodationUnitModal.value = true;
  openedUnit.value = unit;
  openedUnitRoom.value = room;

  if (room) {
    GATrackEvent({
      event: 'show_acc_room',
      language: activeLocale.code,
      action: 'open',
      label: 'Open accommodation room',
      value: accommodation.link,
      items: [
        {...GATrackerItemAccommodation.value, ...{item_room: room.title}}
      ]
    });
  } else {
    GATrackEvent({
      event: 'show_acc_unit',
      language: activeLocale.code,
      action: 'open',
      label: 'Open accommodation unit',
      value: accommodation.link,
      items: [
        {...GATrackerItemAccommodation.value, ...{item_unit: unit.title}}
      ]
    });
  }

}

const closeUnitModal = () => {
  accommodationUnitModal.value = false
  openedUnit.value = null;
  openedUnitRoom.value = null;
}

const showLocationAdditionalInfo = (idRegion) => {
  touristRegionModal.value = true
  touristRegionId.value = idRegion

  GATrackEvent({
    event: 'show_location_add_info',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation location info modal',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const closeTouristRegionModal = (idRegion) => {
  touristRegionModal.value = false;
}

const showContactPhoneModal = () => {
  ownerContactPhoneModal.value = true;


  GATrackEvent({
    event: 'show_detail_owner_phone',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation host phone',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const showContactWhatsappModal = () => {
  ownerContactWhatsAppModal.value = true;


  GATrackEvent({
    event: 'show_detail_owner_whatsapp',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation host whatsapp',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const showContactChatModal = () => {
  ownerContactModal.value = true;


  GATrackEvent({
    event: 'show_detail_owner_chat',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation contact with host',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const open3DVisualization = () => {
  virtualPresentationModal.value = true;

  GATrackEvent({
    event: 'show_acc_3d_visualization',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation visualization',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const openVideoModal = () => {
  videoPresentationModal.value = true;

  GATrackEvent({
    event: 'show_accommodation_video_modal',
    language: activeLocale.code,
    action: 'open',
    label: 'Open accommodation video modal',
    value: accommodation.link,
    items: [
      GATrackerItemAccommodation.value
    ]
  });
}

const scrollToReveiws = () => {
  if (reviews_content.value) {
    reviews_content.value.scrollIntoView({behavior: 'smooth'});

    GATrackEvent({
      event: 'scroll_to_reviews_detail',
      language: activeLocale.code,
      action: 'scroll',
      label: 'scroll to reviews',
      value: accommodation.link,
      items: [
        GATrackerItemAccommodation.value
      ]
    });
  }
}

const showReservation = () => {
  if (reservationContent) {
    reservationContent.value.showReservation();
  }
}

const fullEquipList = ref<boolean>(false);

const hasRatings = computed(() => {
  return Object.keys(accommodation.reviewNumeredRating).some(key => accommodation.reviewNumeredRating[key] > 0);
});

const progressBarWidth = (rating) => {
  if (accommodation.review_count === 0) return 0;
  return Math.round((accommodation.reviewNumeredRating[rating] / accommodation.review_count) * 100);
};

</script>



